import React, { useState } from 'react';
import { Modal, Button, Typography } from "antd";
import styled from "styled-components";
const StyledSpan = styled.span`
color: #636980;
font-size: 14px;
font-weight: 400;

`
function RoleAccountant() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <Typography.Link
        onClick={showModal}
        style={{ textDecoration: "underline", marginRight: "15px" }}
      >
        Click to View Job Description
      </Typography.Link>
      <Modal
        title="Job Description"
        open={isModalOpen}
        onCancel={handleCancel}
        width={1100}
        style={{ maxHeight: '700px', overflowY: 'auto', paddingBottom: '15px', borderRadius: '8px' }}
        footer={null}
      >

        <div>
          <p style={{ fontSize: "15px", fontweight: "500" }}>Role – Accountant</p>
          <StyledSpan>
            <p>
              This role requires strong analytical skills, proficiency in accounting software, and a solid understanding
              of accounting principles.
            </p>
            Key Responsibilities:
            <ul>
              <li>Record and manage daily financial transactions, including accounts payable, accounts receivable, and general ledger entries.</li>
              <li>Prepare and analyze financial statements, including balance sheets, income statements, and cash flow statements.</li>
              <li>Perform month-end and year-end closing processes.</li>
              <li>Ensure compliance with local, state, and federal tax regulations, and assist with tax filings.</li>
              <li>Conduct regular audits to ensure accuracy in financial records and identify discrepancies.</li>
              <li>Reconcile bank statements and monitor cash flow.</li>
              <li>Assist in budget preparation and financial forecasting.</li>
              <li>Support internal and external audits by providing required documentation and explanations.</li>
              <li>Maintain and update financial policies and procedures.</li>
              <li>Collaborate with other departments to provide financial insights and guidance.</li>
            </ul>
            Qualifications and Skills:
            <ul>
              <li>Bachelor’s degree in Accounting, Finance, or a related field.</li>
              <li>Professional certifications such as CPA, ACCA, or equivalent are a plus.</li>
              <li>Proven experience as an accountant or in a similar role.</li>
              <li>Proficiency in accounting software (e.g., QuickBooks, SAP, or Tally).</li>
              <li>Strong knowledge of accounting principles, standards, and regulations.</li>
              <li>Excellent analytical and problem-solving skills.</li>
              <li>Attention to detail and high level of accuracy.</li>
              <li>Strong organizational and time management skills.</li>
              <li>Effective communication and teamwork abilities.</li>
            </ul>
          </StyledSpan>
        </div>
      </Modal>
    </>
  );
}

export default RoleAccountant;

